"use strict";

const namespace = "LogoDynamicCards";

function getModuleStore(module) {
    let moduleStore = window[namespace][module];
    if (!moduleStore) {
        moduleStore = {};
        window[namespace][module] = moduleStore;
    }
    return moduleStore;
}

function getStorage(module, prop, val) {
    let moduleStore = getModuleStore(module);

    let store = moduleStore[prop];
    if (!store) {
        moduleStore[prop] = val;
        store = val;
    }

    return store;
}

function setStorage(module, prop, val) {
    let moduleStore = getModuleStore(module);
    moduleStore[prop] = val;

    return val;
}

function init() {
    if (!window[namespace]) {
        window[namespace] = {};
    }
}

init();

module.exports = {
    getStorage: getStorage,
    setStorage: setStorage,
};
